import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from '../custom-profile-and-preferences.service';

@Component({
    selector: 'app-custom-profile-and-preferences',
    templateUrl: './custom-profile-and-preferences.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class CustomProfileAndPreferencesComponent implements OnInit {
  tabSelected: string = 'User';
  smallerDevice: boolean;
  userData: any;
  selecTabVal = 'Perfil do Usuário';
  tabDataArray = [
    { key: 'User', value: 'Perfil do Usuário' },
    { key: 'Account', value: 'Informações da conta' },
  ];

  constructor(
    private readonly pfservice: CustomProfileAndPreferencesService,
    private readonly user: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.user
      .get()
      .pipe(take(1))
      .subscribe((data) => {
        if (data !== undefined) {
          this.userData = data;
          this.pfservice.getUserAccountDataFromDb(this.userData.userName);
        }
      });
  }

  tabNavigationDropDown(e): void {
    this.tabSelected = e.key;
  }
  tabNavigation(id): void {
    this.tabSelected = id;
  }
}
